// extracted by mini-css-extract-plugin
export default {"checkbox":"aWi7r2cUElpDF0MPg_Ak"};